/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlatformStreakLeaderboardEntry } from './PlatformStreakLeaderboardEntry';
import {
    PlatformStreakLeaderboardEntryFromJSON,
    PlatformStreakLeaderboardEntryFromJSONTyped,
    PlatformStreakLeaderboardEntryToJSON,
    PlatformStreakLeaderboardEntryToJSONTyped,
} from './PlatformStreakLeaderboardEntry';

/**
 * 
 * @export
 * @interface PlatformStreakLeaderboardResponse
 */
export interface PlatformStreakLeaderboardResponse {
    /**
     * 
     * @type {string}
     * @memberof PlatformStreakLeaderboardResponse
     */
    configId: string;
    /**
     * 
     * @type {string}
     * @memberof PlatformStreakLeaderboardResponse
     */
    configName: string;
    /**
     * 
     * @type {Array<PlatformStreakLeaderboardEntry>}
     * @memberof PlatformStreakLeaderboardResponse
     */
    entries: Array<PlatformStreakLeaderboardEntry>;
    /**
     * 
     * @type {number}
     * @memberof PlatformStreakLeaderboardResponse
     */
    total: number;
    /**
     * Rank of the authenticated user (null if not on leaderboard)
     * @type {number}
     * @memberof PlatformStreakLeaderboardResponse
     */
    currentUserRank?: number;
}

/**
 * Check if a given object implements the PlatformStreakLeaderboardResponse interface.
 */
export function instanceOfPlatformStreakLeaderboardResponse(value: object): value is PlatformStreakLeaderboardResponse {
    if (!('configId' in value) || value['configId'] === undefined) return false;
    if (!('configName' in value) || value['configName'] === undefined) return false;
    if (!('entries' in value) || value['entries'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function PlatformStreakLeaderboardResponseFromJSON(json: any): PlatformStreakLeaderboardResponse {
    return PlatformStreakLeaderboardResponseFromJSONTyped(json, false);
}

export function PlatformStreakLeaderboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformStreakLeaderboardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'configId': json['configId'],
        'configName': json['configName'],
        'entries': ((json['entries'] as Array<any>).map(PlatformStreakLeaderboardEntryFromJSON)),
        'total': json['total'],
        'currentUserRank': json['currentUserRank'] == null ? undefined : json['currentUserRank'],
    };
}

export function PlatformStreakLeaderboardResponseToJSON(json: any): PlatformStreakLeaderboardResponse {
    return PlatformStreakLeaderboardResponseToJSONTyped(json, false);
}

export function PlatformStreakLeaderboardResponseToJSONTyped(value?: PlatformStreakLeaderboardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configId': value['configId'],
        'configName': value['configName'],
        'entries': ((value['entries'] as Array<any>).map(PlatformStreakLeaderboardEntryToJSON)),
        'total': value['total'],
        'currentUserRank': value['currentUserRank'],
    };
}

